module.exports = __webpack_public_path__ + "img/GK9905-GK.474f1605.jpg";